import { FIELDS } from "lib"

export const IDENTIFICATION_TYPE_TABLE_COLUMNS = [
    { id: FIELDS.identificationTypeCode.key, label: FIELDS.identificationTypeCode.name },
    { id: FIELDS.description.key, label: FIELDS.description.name },
    { id: FIELDS.name.key, label: FIELDS.name.name },
]